import React from "react";
import Tree from "./Tree";
import "./TreeChildren.css";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { updateLocalSetting } from "../Environment";
// import { useNavigate, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { useTheme } from "../contexts/ThemeContext";

function TreeChildren(props) {
    const navigate = useNavigate();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery({
        query: "(max-device-width: 450px)",
    });
    const userSub = props.userSub;

    function getBestValue(value, editedValue) {
        if (editedValue) {
            return editedValue;
        } else {
            return value;
        }
    }

    const feedItemOnClick = (e) => {
        let metaSourceName = e.target.dataset.name;
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue([e.target.dataset.id], "selectedNodeId");
            record.setValue(false, "isParent");
            record.setValue([], "filterTerms");
            record.setValue([], "selectedSentimentPostIds");
            record.setValue([], "selectedLeads");
            record.setValue(metaSourceName, "metaSourceName");
            record.setValue("Articles from ", "metaDescription");
            record.setValue(false, "isBookmarkView");
            record.setValue(false, "isPostNoteView");

            record.setValue(false, "isAdvancedSearch");
            record.setValue("", "hasPhrase");
            record.setValue("", "withoutWords");
            record.setValue("", "withWords");
            record.setValue("", "searchScope");
            record.setValue("", "searchTime");
            record.setValue(false, "allSubscriptions");

            record.setValue(false, "isRightNavActivated");
            record.setValue("{}", "tagData");
            record.setValue(false, "isAddSourcePageActivated");
        });

        updateLocalSetting("isFullScreenMenuActivated", false);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue([], "selectedLeads");
        });

        if (isSmallScreen) {
            updateLocalSetting("isNavActivated", false);
        }

        navigate("/home");
        window.scrollTo(0, 0);
    };

    return (
        <div className={`tree-children-container`}>
            {userSub.map((childEdge, childKey) => (
                <div key={childKey}>
                    {childEdge.node.parent != null ? (
                        <div>
                            {childEdge.node.parent.id === props.edge.node.id ? (
                                <div className={`tree-children-items`}>
                                    <div className="tree-children-x">
                                        <span>
                                            {childEdge.node.source
                                                .source_icon ? (
                                                <img
                                                    width={18}
                                                    height={18}
                                                    className={`source-icon`}
                                                    src={
                                                        childEdge.node.source
                                                            .source_icon
                                                    }
                                                    alt=""
                                                />
                                            ) : (
                                                <span>
                                                    {" "}
                                                    &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp;
                                                </span>
                                            )}
                                        </span>
                                        <span
                                            className={`feed-item theme-${theme.foreground}`}
                                            onClick={feedItemOnClick}
                                            data-id={childEdge.node.source.id}
                                            data-name={getBestValue(
                                                childEdge.node.source
                                                    .name,
                                                childEdge.node.source.edited_name
                                            )}
                                        >
                                            {childEdge.node.name}{" "}
                                        </span>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            ))}

            <div className={`xsublist-spacing`}></div>
        </div>
    );
}

export default TreeChildren;
